import * as React from 'react';
import { Control, LocalForm } from 'react-redux-form';

import { OptionsViewModel } from '@models/common.models';
import { CreditCardPaymentViewModel } from '@models/Payment';

import { PaymentPurpose } from '@models/Payment';

function getCreditCardLastFour(creditCard: CreditCardPaymentViewModel): string {
  if (!creditCard.number) {
    return '—';
  }
  return creditCard.number.substr(Math.max(creditCard.number.length - 4, 0), Math.min(4, creditCard.number.length));
}

export interface PaymentSaveAccountsProperties {
  readonly affiliatedAccounts: OptionsViewModel[];
  readonly creditCardBalance?: CreditCardPaymentViewModel;
  readonly creditCardInitial?: CreditCardPaymentViewModel;
  readonly paymentPurpose: PaymentPurpose;
  readonly buttonRef?: null | ((button: HTMLButtonElement) => void);
  readonly submit: (accountIdBalance: number | undefined, accountIdInitial: number | undefined) => void;
  readonly toggleBlah: () => void;
}

export function PaymentSaveAccounts(props: PaymentSaveAccountsProperties): JSX.Element {
  if (props.affiliatedAccounts.length < 1 || (!props.creditCardBalance && !props.creditCardInitial)) {
    return <p className="error">Missing required information in properties.</p>;
  }

  const accountOptions = props.affiliatedAccounts.map((ovm, i) => (
    <option key={i} value={ovm.id}>
      {ovm.value}
    </option>
  ));
  accountOptions.unshift(<option value="" />);

  return (
    <div className="row center-xs">
      <div className="row-xl-4 row-lg-5 row-md-6">
        <LocalForm hideNativeErrors={false} onSubmit={m => props.submit(m.accountIdBalance, m.accountIdInitial)}>
          {props.creditCardInitial && (
            <div className="form-control">
              <label>
                Save {props.paymentPurpose === PaymentPurpose.Contract ? ' initial payment' : ''} credit card (
                {getCreditCardLastFour(props.creditCardInitial)}) to account:
              </label>
              <Control.select model=".accountIdInitial">{accountOptions}</Control.select>
            </div>
          )}
          {props.creditCardBalance && (
            <div className="form-control">
              <label>
                Save balance payment credit card ({getCreditCardLastFour(props.creditCardBalance)}) to account:
              </label>
              <Control.select model=".accountIdBalance">{accountOptions}</Control.select>
            </div>
          )}
          {props.buttonRef ? (
            <button className="btn btn-hidden" type="submit" ref={props.buttonRef}>
              Submit
            </button>
          ) : (
            <button className="btn btn-primary" type="submit">
              Submit
            </button>
          )}
        </LocalForm>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/payment/_components/payment-save-accounts.component.tsx